export default __webpack_public_path__ + "static/media/SALUDOS_11.87633c1a.png";